import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createCompanyAdminRequest } from "../../../reducers/company/companyAdmins.reducer";
import { Grid, FormControl, FormLabel } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { isEmpty, get, isNull, forEach, values, uniq } from "lodash";
import { useForm } from "react-hook-form";
import {
  Modal,
  Input,
  Button,
  FlashMessage,
  Radio,
  AsyncSelect,
} from "../../../components/common";
import { rootReducersState } from "../../../reducers";
import { companyUserAccessLevel } from "../../../utils/appConstants";
import Avatar from "../../../components/common/AvtarImage";
import adminServices from "../../../services/companyAdmin.services";
let searchDelay: any = null;
type Inputs = {
  companyHandlerId: number;
  accessLevel: "";
  email: string;
  confirm_email: string;
  first_name: string;
  last_name: string;
  "chooseRole": string;
  search: string;
};
interface FormProps {
  handleClose: () => void;
  showModal: boolean;
}

const _ = { isEmpty, get, isNull, forEach, values, uniq };

const formatCreateCompanyAdminError = (
  message: string,
  fieldErrors: Record<string, string> | undefined | null
): string => {
  if (!fieldErrors || _.isEmpty(fieldErrors)) {
    return message?.trim() || "Something went wrong. Please try again.";
  }
  const parts = _.uniq(
    _.values(fieldErrors).filter(
      (v): v is string => typeof v === "string" && Boolean(v?.trim())
    )
  );
  if (parts.length) return parts.join(" ");
  return message?.trim() || "Something went wrong. Please try again.";
};

const AddAdminForm = (props: FormProps) => {
  const { showModal, handleClose } = props;
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const confirm_email = useRef({});

  const {
    companyAdmins: {
      createFlag,
      createLoading,
      createMessage,
      data: companyAdminData,
      error,
    },
  } = useSelector(({ company }: rootReducersState) => company);
  const [companyHandlerId, setCompanyHandlerId] = useState<number>();
  const [accessLevel, setAccessLevel] = useState<string>("admin");
  console.log(accessLevel, "accessLevel");
  const [status, setStatus] = useState<string>("internal");
  const { register, handleSubmit, formState: { errors }, reset, control, watch, setError } =
    // useForm<Inputs>();
    useForm<Inputs>({
      defaultValues: {
        chooseRole: "admin", // ✅ Make sure this matches the Radio `name`
      },
    });
  confirm_email.current = watch("email", "");

  const resetForm = () => {
    reset(
      {
        accessLevel: "",
        companyHandlerId: undefined,
      },
      {
        errors: true, // errors will not be reset
        dirtyFields: true, // dirtyFields will not be reset
        isDirty: true, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    );
  };

  const typeOptions = [
    { label: "Internal", value: "internal" },
    { label: "Invite", value: "invite" },
  ];

  useEffect(() => {
    if (createFlag === "success") {
      resetForm();
      handleClose();
      setStatus("internal");
      FlashMessage(createMessage);
    } else if (createFlag === "failed") {
      FlashMessage(
        formatCreateCompanyAdminError(createMessage, error),
        "error"
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createFlag, createMessage, error]);

  const searchAdmins = (search: string) =>
    new Promise((resolve) => {
      clearTimeout(searchDelay);
      searchDelay = setTimeout(async () => {
        if (_.isEmpty(search)) {
          resolve([]);
          return;
        }
        const response = await adminServices.searchCompanyAdmins(search);
        const users = (_.get(response, "data.data", []) || []).map((user) => ({
          value: user.id,
          label: user.name,
          profile_image: user.profile_image,
        }));
        resolve(users);
      }, 1000);
    });

  const onSubmit = (formDataPayload) => {
    if (status === "internal") {
      // Check if User already exists in the list
      const userExists = companyAdminData?.find(
        (row) => row.id === companyHandlerId
      );

      if (userExists) {
        FlashMessage(
          "User already has permission, please select different",
          "error"
        );
      } else {
        dispatch(
          createCompanyAdminRequest({
            companyHandlerId,
            accessLevel,
            status: 1,
          })
        );
      }
    } else {
      dispatch(
        createCompanyAdminRequest({
          status: 0,
          accessLevel,
          companyHandlerId: 0,
          email: _.get(formDataPayload, "email"),
          first_name: _.get(formDataPayload, "first_name"),
          last_name: _.get(formDataPayload, "last_name"),
        })
      );
    }
  };

  useEffect(() => {
    handleErrors(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleErrors = (response: any) => {
    if (!response || _.isEmpty(response)) return;
    _.forEach(response, (value, key: any) => {
      const fieldName =
        key === "undefined" || key === undefined ? "email" : key;
      setError(fieldName, {
        type: "manual",
        message: typeof value === "string" ? value : String(value),
      });
    });
  };

  return (
    <Modal
      visible={showModal}
      size="medium"
      title={`Add new Role`}
      closeOnBackDrop={false}
      className="admin-profile-add-modal"
      closeButton={showModal}
      onClose={() => {
        handleClose();
        setStatus("internal");
      }}
    >
      <form className={"invite-admin-form"} onSubmit={handleSubmit(onSubmit)}>
        <div className="add-new-admin-form">
          <div className="search-by-name-section">
            <Grid>
              <Radio
                control={control}
                labelPlacement="end"
                defaultValue="internal"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setStatus(_.get(e, "target.value", ""));
                  reset({});
                }}
                options={typeOptions}
                className="ml-20"
                name={""}
              />
            </Grid>
            {status === "internal" ? (
              <div>
                <Grid
                  container
                  spacing={2}
                  text-align="center"
                  alignItems="center"
                  className="search-by-name-wrapper"
                >
                  <Grid item xs={12} ref={wrapperRef}>
                    <AsyncSelect
                      name="search"
                      placeholder="Search User"
                      externalLabel={{ label: "Search By Name" }}
                      icon={<SearchIcon />}
                      onStartSearching={searchAdmins}
                      validationObj={errors}
                      control={control}
                      noOptionsMessage="No users found"
                      onChange={(user) => setCompanyHandlerId(user?.value)}
                      formatOptionLabel={(option, { context }) =>
                        context === "menu" ? (
                          <div className="admin-search-option">
                            <Avatar src={option.profile_image} size="xsm" />
                            <span>{option.label}</span>
                          </div>
                        ) : (
                          option.label
                        )
                      }
                      rules={{
                        required: {
                          value: true,
                          message: "Please select user",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            ) : (
              <div>
                <Grid
                  container
                  spacing={2}
                  text-align="center"
                  alignItems="center"
                  className="search-by-name-wrapper"
                >
                  <Grid item xs={12} ref={wrapperRef}>
                    <Grid container spacing={3}>
                      <Grid item xs={6}>
                        <FormLabel id=""> First Name </FormLabel>
                        <Input
                          // name={"first_name"}
                          validationObj={errors}
                          placeholder="First Name"
                          {...register("first_name", {
                            required: {
                              value: true,
                              message: "Please enter first name",
                            },
                          })}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormLabel id=""> Last Name </FormLabel>
                        <Input
                          // name={"last_name"}
                          validationObj={errors}
                          placeholder="Last Name"
                          {...register("last_name", {
                            required: {
                              value: true,
                              message: "Please enter last name",
                            },
                          })}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormLabel id=""> Email </FormLabel>
                        <Input
                          // name={"email"}
                          validationObj={errors}
                          placeholder="Email"
                          {...register("email", {
                            required: {
                              value: true,
                              message: "Please enter email",
                            },
                          })}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormLabel id="">Confirm Email </FormLabel>
                        <Input
                          // name={"confirm_email"}
                          validationObj={errors}
                          placeholder="Confirm Email"
                          {...register("confirm_email", {
                            required: {
                              value: true,
                              message: "Please enter confirm email",
                            },
                            validate: (value) =>
                              value === confirm_email.current ||
                              "The re-entered email do not match",
                          })}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            )}
            <Grid container spacing={2} className="invite-by-email">
              <Grid item xs={12} sm={12}>
                <FormControl>
                  <div className="radio-wrapper">
                    <FormLabel id="choose-admin-role-label">
                      Choose role
                    </FormLabel>
                    {/* <Radio
                      // name="Choose Role"
                      control={control}
                      validationObj={errors}
                      labelPlacement="end"
                      defaultValue="admin"
                      // onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                      //   setAccessLevel(_.get(e, "target.value", ""));
                      // }}
                      {...register("Choose Role", {
    required: {
      value: true,
      message: "Please select a role",
    },
    onChange: (e) => {
      setAccessLevel(_.get(e, "target.value", ""));
    },
  })}
                      options={companyUserAccessLevel}
                    /> */}
                    <Radio
                      name="chooseRole"
                      control={control}
                      validationObj={errors}
                      labelPlacement="end"
                      defaultValue="admin"
                      options={companyUserAccessLevel}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setAccessLevel(_.get(e, "target.value", ""))
                      }
                      rules={{
                        required: {
                          value: true,
                          message: "Please select a role",
                        },
                      }}
                    />

                  </div>
                  <div className="text-center btns-wrapper">
                    <Button
                      type="button"
                      className="post-job-btn invite-admin-btn btn-secondary"
                      onClick={() => {
                        handleClose();
                        setStatus("internal");
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      disabled={!companyHandlerId && !accessLevel}
                      className="post-job-btn invite-admin-btn primary-btn"
                      loading={createLoading}
                    >
                      Invite
                    </Button>
                  </div>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default AddAdminForm;
